import { AlertCode } from 'shared/types/checkout';
import { createAppSelector } from 'store/root/utils';
import { makePropertySelector } from 'store/utils';

const getPropertySelector = makePropertySelector('checkout');

export const getAlert = getPropertySelector('alert');
export const getIsCTADisabled = getPropertySelector('isCTADisabled');
export const getIsPayPalCTAPending = getPropertySelector('isPayPalCTAPending');
export const getIsStripeCTAPending = getPropertySelector('isStripeCTAPending');
export const getFreeOrderCTAPending = getPropertySelector(
  'isFreeOrderCTAPending',
);
export const getHasCartLoadFailure = createAppSelector((state) =>
  [
    AlertCode.CART_LOAD_FAILED,
    AlertCode.SKU_NOT_PROVIDED,
    AlertCode.FALLBACK_WITH_RELOAD_INFORMATION,
    AlertCode.ORDER_ALREADY_PLACED,
    AlertCode.PRODUCT_NOT_FOUND,
    AlertCode.PRODUCT_UNAVAILABLE_TO_BUY,
  ].includes(state.checkout.alert.code!),
);
export const getSelectedCurrency = getPropertySelector('selectedCurrency');
